import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'
import { materialObject } from '../material/materialObject'

export const materialInventoryType = enumerated({
  entry: 'Entrada',
  exit: 'Saída',
})

export const materialInventoryObject = z.object({
  id: z.string().uuid(),
  materialId: materialObject.shape.id,
  quantity: z.number().int(),
  sourceFilter: z.string().nullish(),
  type: materialInventoryType,
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type MaterialInventoryType = z.infer<typeof materialInventoryObject>

export const propertyMap = {
  id: sql`material_inventory.id`,
  materialId: sql`material_inventory.material_id`,
  quantity: sql`material_inventory.quantity`,
  type: sql`material_inventory.type`,
  clientId: sql`material_inventory.client_id`,
  insertUserId: sql`material_inventory.insert_user_id`,
  sourceFilter: sql`material_inventory.source_filter`,
  editUserId: sql`material_inventory.edit_user_id`,
  createdAt: sql`material_inventory.created_at`,
  updatedAt: sql`material_inventory.updated_at`,
  deletedAt: sql`material_inventory.deleted_at`,
}
